import { useEffect, useState } from "react";


/**
 * @typedef {Object} useValidateInvalidFieldValue
 */

/**
 *
=
 * @returns {isValidValue, setAnswer}
 */

export const useValidateInvalidFieldValue = () => {

  const [isValidValue, setIsValidValue] = useState(false);
  const [answer, setAnswer] = useState(null);

  useEffect(() => {

    if (answer !== undefined && answer !== null) {
      let emojiRefex = answer.match(/\p{Emoji_Presentation}/gu);

      if (!emojiRefex) {
        emojiRefex = answer.match(/[\xA0\x00-\x09\x0B\x0C\x0E-\x1F\x7F]+(.+)[\xA0\x00-\x09\x0B\x0C\x0E-\x1F\x7F]+(.+)/gu);
      }

      emojiRefex ? setIsValidValue(true) : setIsValidValue(false);

    }

  }, [answer]);


  return { isValidValue, setAnswer };
};
